export default {
  en: {
    title: 'Network - visualisation',
    communityTitle: 'Network - {communityName} visualisation',
    pageHeader: 'Network',
    visualisationHeaderName: 'Visualisation',
    communityVisualisationHeaderName: '{communityName} visualisation',
    learnMore: 'Learn more',
    emptyTitle: 'You have not added any suppliers',
    emptySubtitle: 'Add a supplier to see them on the network visualisation',
    emptyCTA: 'Add a supplier',
    description:
      'Visualise all of your immediate first degree suppliers and anonymised nth degree suppliers beyond that.',
    complianceKey: 'Compliance key',
    filteredBy: 'Filtered by',
    compliancePercentage: 'Compliance:',
    incompleteAssessment: 'Assessment incomplete',
    unclaimed: 'Unclaimed supplier',
    viewProfile: 'View profile',
    error: 'Failed to load network. Please try again.',
    nav: {
      visualisation: 'Visualisation',
      dataTable: 'Data table',
      yourSupplyChain: 'Your supply chain',
      yourSupplyChainDataTable: 'Your supply chain data table',
      communitySupplyChain: 'Community supply chain',
    },
    key: {
      '0': '0',
      '50': '50',
      '100': '100',
      title: 'Key',
      concentrationRisk: 'Concentration risk',
      potentialCR: 'potential risk | potential risks',
      compliance: 'Compliance %',
      show: 'Show',
      hide: 'Hide',
      mint: '100%',
      blue: '70% - 99%',
      yellow: '50% - 69%',
      orange: '30% - 49%',
      red: '0% - 29%',
      community: 'Community member',
    },
    nthPartyConnection: '{nth} party connection',
    nthParty: {
      '3': 'third-party supplier | third-party suppliers',
      '4': 'fourth-party supplier | fourth-party suppliers',
      '5': 'fifth-party supplier | fifth-party suppliers',
      '6': 'sixth-party supplier | sixth-party suppliers',
      '7': 'seventh-party supplier | seventh-party suppliers',
      '8': 'eighth-party supplier | eighth-party suppliers',
      '9': 'ninth-party supplier | ninth-party suppliers',
      '10': 'tenth-party supplier | tenth-party suppliers',
    },
    config: {
      network: 'Network visualisation',
      enableNetworkTitle: 'Enable network visualisation',
      enableNetworkDesc1:
        'By enabling visualisation, you will be able to see the names of all organisations within your supply chain, including 4th, 5th and 6th parties.',
      enableNetworkDesc2: 'Your clients will also be able to see the names of your suppliers.',
      fetchError: 'Failed to get network configuration.',
      updateError: 'Failed to update network configuration.',
      excludeSuppliersTitle: 'Exclude suppliers',
      excludeSuppliersDesc:
        'Select which suppliers you would like to exclude from the visualisation, the names of these suppliers will not be shared with your clients.',
      excludeSuppliersPlaceholder: 'Search...',
    },
    placeholder: {
      title: 'Visualise your supply chain network',
      description: {
        first:
          'By enabling visualisation, you will be able to see the names of all organisations within your supply chain, including 4th, 5th and 6th parties. Your clients will also be able to see the names of your suppliers.',
        second:
          'The Risk Ledger network visualisation allows all organisations to see the breadth and depth of their supply chain, identify concentration risk and begin to work together to Defend-as-One™.',
      },
      enable: 'Enable visualisation',
    },
    filters: {
      filter: 'Filter',
      title: 'Filter your network',
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      pii: 'PII',
      labels: 'Labels',
      selectTag: 'Select a tag...',
      selectLabel: 'Select a label...',
      apply: 'Apply',
    },
    switch3d: 'See in 3D',
    fullscreen: 'Fullscreen',
    ordinalNumber: '{number}{ordinal}',
    ordinals: {
      zero: 'n/a',
      one: 'st',
      two: 'nd',
      few: 'rd',
      many: 'n/a',
      other: 'th',
    },
    table: {
      title: 'Network - table view',
      headerName: 'Table view',
      emptyTitle: 'Organisations',
      emptyDescription: 'No organisations could be found',
      errorTitle: 'Organisations',
      errorDescription: 'Failed fetching organisations',
      entityName: 'Organisation',
      results: '{n} organisation | {n} organisations',
      resultsOutOf: '{0} out of {1}',
      isPotentialConcentrationRisk: 'Potential concentration risk',
      anonymisedSupplierCount: '{count} anonymised supplier | {count} anonymised suppliers',
      communityMember: 'Community member',
      filters: {
        name: 'Name',
        degree: 'Degree',
        numClients: 'No. of clients',
        clientNames: 'Client names',
        numSuppliers: 'No. of suppliers',
        supplierNames: 'Supplier names',
        potentialConcentrationRisk: 'Potential concentration risk',
        isRisk: 'Is potential concentration risk',
        isNotRisk: 'Is not potential concentration risk',
        sector: 'Sector',
        country: 'Location',
      },
      columns: {
        name: 'Organisation',
        degree: 'Degree',
        numClients: 'No. of clients',
        clientNames: 'Client names',
        numSuppliers: 'No. of suppliers',
        supplierNames: 'Supplier names',
        supplierNamesDesc: "Doesn't include anonymised suppliers",
        potentialConcentrationRisk: 'Potential concentration risk',
        sector: 'Sector',
        country: 'Location',
        actions: 'Actions',
      },
      degrees: {
        nthParty: '{ordinal} party supplier',
      },
      actions: {
        view: 'View',
      },
      export: 'Export',
      exportError: 'There was an error attempting to export the network data table',
      exportTitle: 'Network-Data-Table',
    },
    openRisk: 'Open risk',
    communityMember: 'Community member',
  },
};
